import React, { memo } from 'react';

import Responsive from '@/components/Responsive';

import SortMenuItemsDesktop from './index.desktop';
import SortMenuItemsMobile from './index.mobile';
import { BaseSortMenuItem, SortMenuItemsProps } from './types';

function SortMenuItems<T extends BaseSortMenuItem>(props: SortMenuItemsProps<T>) {
  return (
    <Responsive>
      <Responsive.Default>
        <SortMenuItemsDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <SortMenuItemsMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
}

export default memo(SortMenuItems) as typeof SortMenuItems;
